var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnomaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 35.5L26.2069 26.7069M1 16.1552C1 8.06134 7.56134 1.5 15.6552 1.5C23.749 1.5 30.3103 8.06134 30.3103 16.1552C30.3103 24.249 23.749 30.8103 15.6552 30.8103C7.56134 30.8103 1 24.249 1 16.1552Z",
    stroke: "#353A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1673 12.3494L21.168 15.6133M15.3453 18.8214L19.693 10.1499C20.3026 8.93414 22.038 8.93446 22.6472 10.1505L26.9909 18.8219C27.5411 19.9205 26.7424 21.214 25.5137 21.214H16.8223C15.5933 21.214 14.7945 19.92 15.3453 18.8214ZM21.5807 18.4084C21.5807 18.6363 21.3959 18.8211 21.168 18.8211C20.94 18.8211 20.7552 18.6363 20.7552 18.4084C20.7552 18.1805 20.94 17.9957 21.168 17.9957C21.3959 17.9957 21.5807 18.1805 21.5807 18.4084Z",
    stroke: "#353A0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41797 19.9996H6.66797L9.5013 7.66602L13.7513 25.3743L17 21.5",
    stroke: "#353A0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnomaly);
export default __webpack_public_path__ + "static/media/Anomaly.e15cff7fbc6cea3f50903e6e99080760.svg";
export { ForwardRef as ReactComponent };